import { useTranslation } from 'react-i18n-lite'

import { Text } from '@yes.technology/react-toolkit'

import { Container, Content, StyledButton, Image } from './styles'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from 'state/store'
import { interactionModelOperations } from 'modules/interaction/redux'
import moment from 'moment'

const IMAGE_URL =
  'https://s3.amazonaws.com/yes.network/static-files/draft-not-found.png'

function GenericErrorPage() {
  const dispatch = useAppDispatch()

  const { t } = useTranslation()
  const navigate = useNavigate()

  const startInteraction = () => {
    dispatch(
      interactionModelOperations.setConfigToNewInteraction(moment().format())
    )

    const queryParams = new URLSearchParams(location.search)
    queryParams.delete('draft_interaction_uuid')
    navigate('', { replace: true, state: { search: queryParams.toString() } })
  }

  return (
    <Container>
      <Content>
        <Image src={IMAGE_URL} />
        <Text as='h3' variant='heading-emphasis-01'>
          {t('draft-not-found.des')}
        </Text>
        <Text as='p' variant='content-04'>
          {t('draft-not-found.complement')}
        </Text>
        <StyledButton onClick={startInteraction}>
          {t('draft-not-found.btn-label')}
        </StyledButton>
      </Content>
    </Container>
  )
}

export default GenericErrorPage
